<template>
  <div class="job">
    <form @submit.prevent="onSubmit" novalidate>
      <b-field
        label="Scheduled Delivery"
        custom-class="labelRequestDelivery"
        horizontal
      >
        <b-datepicker
          v-model="scheduledDate"
          locale="en-GB"
          placeholder="Click to select..."
          icon="calendar-today"
          trap-focus
        >
        </b-datepicker>
      </b-field>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <b-button
        type="is-primary"
        native-type="submit"
        style="margin-right: 10px"
        >Submit</b-button
      >
      <b-button type="is-warning" native-type="button" @click="cancel()"
        >Cancel</b-button
      >
    </form>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "LoadForm",
  props: {
    edit: Boolean,
    password: Object
  },
  data() {
    return {
      form: {},
      bookingId: null,
      scheduledDate: new Date(),
      job: []
    };
  },
  methods: {
    async onSubmit() {
      const isValid = true;
      if (!isValid) {
        alert("error");
        return;
      }
      this.putJob();
      this.$emit("saved");
    },
    cancel() {
      this.$emit("cancelled");
    },
    async putJob() {
      try {
        await axios.put(
          this.$store.state.apiUrl + "transport/" + this.bookingId,
          {
            action: "TbPutTransportBooking",
            changedFields: {
              scheduledDate: new Date(this.scheduledDate),
              clientCode: this.job[0].clientCode,
              accountCode: this.job[0].accountCode,
              accountName: this.job[0].accountName,
              loadName: this.job[0].loadName,
              pickupAddress: {
                addressName: this.job[0].pickupAddress.addressName,
                address: this.job[0].pickupAddress.address,
                town: this.job[0].pickupAddress.town,
                postcode: this.job[0].pickupAddress.postcode,
                gps: this.job[0].pickupAddress.gps,
                pic: this.job[0].pickupAddress.pic,
                columnPrefix: this.job[0].pickupAddress.columnPrefix
              },
              destinationAddress: {
                addressName: this.job[0].destinationAddress.addressName,
                address: this.job[0].destinationAddress.address,
                town: this.job[0].destinationAddress.town,
                postcode: this.job[0].destinationAddress.postcode,
                gps: this.job[0].destinationAddress.gps,
                pic: this.job[0].destinationAddress.pic,
                columnPrefix: this.job[0].destinationAddress.columnPrefix
              },
              truckName: this.job[0].truckName,
              driverId: this.job[0].driverId,
              driverName: this.job[0].driverName,
              requestedPickupTime: this.job[0].requestedPickupTime,
              requestedDeliveryTime: this.job[0].requestedDeliveryTime,
              contact: this.job[0].contact,
              contactPhone: this.job[0].contactPhone,
              notes: this.job[0].notes,
              qty: this.job[0].qty,
              status: this.job[0].status,
              productName: this.job[0].product,
              estimatedkm: this.job[0].km,
              estimatedWeight: this.job[0].weight,
              qtyType: this.job[0].unit,
              actualQty: 0,
              quotedPrice: this.job[0].rate,
              priceCharged: this.job[0].charged,
              invoiced: false
            }
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async getJob(bookingId) {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl +
            "transport/" +
            bookingId +
            "?mode=app&row_type=transport_booking",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.job = data;
      } catch (error) {
        console.log(error);
      }
    }
  },
  watch: {
    name: {
      handler(p) {
        this.form = JSON.parse(JSON.stringify(p || {}));
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.scheduledDate = new Date(this.$store.state.scheduleddate);
    this.bookingId = this.$store.state.id;
    this.getJob(this.bookingId);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
